import { Dictionary } from 'lodash';
import { CriteriaType } from './criteriaType';

export class Criteria {
  schedulingAttributes: Dictionary<string>;
  time: string;
  distance: number;
  engineHours: number;
  count: number;
  type: CriteriaType;
  criteriaText: string;
  groups: Array<ScheduleVehicle>;
  constructor(){
    this.schedulingAttributes = {};
    this.groups = [];
    this.time = '00:00:00';
    this.distance = 0;
    this.engineHours = 0;
    this.count = 0;
    this.type = CriteriaType.DailyOrRefueling;
    this.criteriaText = '';
  }
}
export class ScheduleVehicle {
  type : string;
  manufacturer : string;
  model : string;
  other : string;
  startYear : number;
  endYear : number;
}
